module.exports = __webpack_public_path__ + "img/gz.8ed070e5.jpg";